import React from "react";
import { Popover } from "@mui/material";
function Dropdown({ triggerButton, content, closeOnClickInside }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  function handleClickInside() {
    if (closeOnClickInside !== false) {
      setAnchorEl(null);
    }
  }
  const open = Boolean(anchorEl);
  const Button = triggerButton;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { onClick: handleClick }), /* @__PURE__ */ React.createElement(
    Popover,
    {
      open,
      anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React.createElement("div", { onClick: handleClickInside }, content)
  ));
}
export {
  Dropdown
};
//# sourceMappingURL=Dropdown.js.map
